// Configuração da API
const API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  ? 'http://localhost:4001'
  : 'https://api.aceagilityclub.com';

export const apiConfig = {
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
};

// Função helper para fazer chamadas à API
export const apiCall = async (endpoint: string, options: RequestInit = {}) => {
  const url = `${apiConfig.baseURL}${endpoint}`;
  
  const config: RequestInit = {
    ...options,
    headers: {
      ...apiConfig.headers,
      ...options.headers,
    },
  };

  // Adicionar token de autenticação se existir
  const token = localStorage.getItem('token');
  if (token) {
    config.headers = {
      ...config.headers,
      'Authorization': `Bearer ${token}`,
    };
  }

  try {
    const response = await fetch(url, config);
    
    // Tentar obter a resposta JSON primeiro
    let responseData;
    try {
      responseData = await response.json();
    } catch (jsonError) {
      // Se não conseguir fazer parse do JSON, usar texto simples
      responseData = await response.text();
    }
    
    if (!response.ok) {
      // Se a resposta contém um campo 'error', usar essa mensagem
      if (responseData && typeof responseData === 'object' && responseData.error) {
        throw new Error(responseData.error);
      }
      // Se não, usar a resposta completa como mensagem de erro
      const errorMessage = typeof responseData === 'string' ? responseData : `HTTP error! status: ${response.status}`;
      throw new Error(errorMessage);
    }
    
    return responseData;
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
}; 